import parcoursJson from "./Simulateur Soregies 1.0.4.json";
const parcours = {
  ...parcoursJson,
};

export default parcours;
